export class Lot {

	public numLot: string;

	public description: string;

	public infosComplementaires: string;

	constructor() {
		this.numLot = '';
		this.description = '';
		this.infosComplementaires = '';

	}
}
